export { default } from "./modal.component";
